import { render, staticRenderFns } from "./ProgramDetailsV2.vue?vue&type=template&id=6106fb56&scoped=true"
import script from "./ProgramDetailsV2.vue?vue&type=script&lang=js"
export * from "./ProgramDetailsV2.vue?vue&type=script&lang=js"
import style0 from "./ProgramDetailsV2.vue?vue&type=style&index=0&id=6106fb56&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6106fb56",
  null
  
)

export default component.exports